import { render, staticRenderFns } from "./CErrorModal.vue?vue&type=template&id=4e6729f1"
import script from "./CErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CErrorModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports